import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import RouteSummary from "./routesummary";

const RouteSummaryPage = () => {
  return (
    <NavHeightAdjust>
      <RouteSummary />
    </NavHeightAdjust>
  );
};

export default RouteSummaryPage;
